import $ from 'jquery'
import slick from 'slick-carousel'

// slick-carousel 2.x の CommonJS 版は import だけでは $.fn.slick を登録せず、初期化関数を返すだけのため明示的に呼ぶ
slick(window, $)

$(function () {
  $('.case-video-slider').slick({
    dots: true,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
    ],
  })
})

$(function () {
  $('#js-case-slider').slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    prevArrow: '<div class="prev"></div>',
    nextArrow: '<div class="next"></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })
})
